import React from "react";
import PeopleIcon from '@mui/icons-material/People';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import ClassIcon from '@mui/icons-material/Class';
import CategoryIcon from '@mui/icons-material/Category';
import HistoryIcon from '@mui/icons-material/History';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import GroupsIcon from '@mui/icons-material/Groups';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import ChildCareIcon from '@mui/icons-material/ChildCare';

const menus = [
    {
        label: 'sidebar.menu.home',
        type: "section",
        children: [
            {
                uri: "/app/meus-dados",
                label: "Meus Dados",
                type: "nav-item",
                icon: <PeopleIcon sx={{fontSize: 20}}/>
            },
        ]
    },
    {
       
        label: 'sidebar.menu.admin',
        type: "collapsible",
        icon: <ManageAccountsIcon sx={{fontSize: 20}}/>,
        children: [
            {
                uri: "/app/listar-areas",
                label: 'Áreas',
                type: "nav-item",
                //icon: <CategoryIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/app/listar-centros-espiritas",
                label: 'Centros Espíritas',
                type: "nav-item",
                //icon: <CategoryIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/app/listar-introdutorios-cursos",
                label: 'Cursos Introdutórios',
                type: "nav-item",
                //icon: <GroupsIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/app/listar-departamentos",
                label: 'Departamentos',
                type: "nav-item",
                //icon: <HolidayVillageIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/app/listar-diretores",
                label: 'Diretores',
                type: "nav-item",
                //icon: <CategoryIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/app/log-de-atividades",
                label: 'Log de Atividades',
                type: "nav-item",
                //icon: <HistoryIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/app/listar-mensagens",
                label: 'Mensagens',
                type: "nav-item",
                //icon: <CategoryIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/app/listar-perfis-de-acesso",
                label: 'Perfis',
                type: "nav-item",
                //icon: <ManageAccountsIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/app/listar-salas",
                label: 'Salas',
                type: "nav-item",
                //icon: <CategoryIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/app/listar-usuarios-registrados",
                label: 'Usuários',
                type: "nav-item",
                //icon: <GroupsIcon sx={{fontSize: 20}}/>
            },
        
        ]
    },
    {
        label: 'sidebar.menu.pessoas',
        type: "collapsible",
        icon: <PeopleIcon sx={{fontSize: 20}}/>,
        children: [
            {
                uri: "/app/listar-associados",
                label: 'Associado',
                type: "nav-item",
            },
            {
                uri: "/app/listar-usuarios",
                label: 'Cadastro Único',
                type: "nav-item",
            },
            {
                uri: "/app/listar-conselhos",
                label: 'Conselho Deliberativo',
                type: "nav-item",
            },
        
        ]
    },
    {
       
        label: 'sidebar.menu.cursosETreinamentos',
        type: "collapsible",
        icon: <ClassIcon sx={{fontSize: 20}}/>,
        children: [
            {
                uri: "/app/listar-atualizar-status-transferir-aluno",
                label: "Atualizar Status ou Transferir Aluno",
                type: "nav-item",
            },
            {
                uri: "/app/listar-avaliacao-de-documentos",
                label: "Avaliação de Documentos",
                type: "nav-item",
            },
            {
                uri: "/app/listar-turmas",
                label: 'Cadastro de Turmas',
                type: "nav-item",
            },
            {
                uri: "/app/listar-certificados",
                label: 'Certificados',
                type: "nav-item",
            },
            {
                uri: "/app/listar-consultar-historico",
                label: 'Consultar Histórico de Cursos',
                type: "nav-item",
            },
            {
                uri: "/app/listar-cursos",
                label: 'Cursos',
                type: "nav-item",
            },
            {
                uri: "/app/listar-turmas-inserir-aluno",
                label: "Inclusão de Alunos na Turma",
                type: "nav-item",
            },
            {
                uri: "/app/listar-cursos-outras-entidades",
                label: "Inclusão de Cursos de Outras Entidades",
                type: "nav-item",
            },
            {
                uri: "/app/listar-curso-lote",
                label: "Lançamento de Curso em Lote",
                type: "nav-item",
            },
            {
                uri: "/app/listar-inscricoes-abertas",
                label: 'Setup de Curso',
                type: "nav-item",
                //icon: <GroupsIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/lista-de-cursos",
                label: 'Matrículas Ensino - Menu',
                type: "nav-item",
                isPublic: true,
                target: '_blank'
            },

        ]
    },
    {
        label: 'sidebar.menu.ijm',
        type: "collapsible",
        icon: <ChildCareIcon sx={{fontSize: 20}}/>,
        children: [
            {
                uri: "/app/listar-menores",
                label: 'Cadastro de Menores',
                type: "nav-item",
            },
            {
                uri: "/lista-de-cursos-mocidade",
                label: 'Matrículas AIJM - Menu',
                type: "nav-item",
                isPublic: true,
                target: '_blank'
            },
        ]
    },
    {

        label: 'sidebar.menu.voluntariado',
        type: "collapsible",
        icon: <VolunteerActivismIcon sx={{fontSize: 20}}/>,
        children: [
            {
                uri: "/app/listar-alocar-voluntariado",
                label: 'Alocação de Voluntários',
                type: "nav-item"
            },
            {
                uri: "/app/listar-atividades",
                label: 'Atividades',
                type: "nav-item",
                //icon: <CategoryIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/app/listar-consultar-historico-voluntariado",
                label: 'Consultar Histórico de Voluntário',
                type: "nav-item",
            },
            {
                uri: "/app/listar-interesse-voluntariado",
                label: 'Interesse Voluntariado',
                type: "nav-item"
            },
            {
                uri: "/app/impressao-de-crachas",
                label: 'Impressão de Crachás',
                type: "nav-item"
            },
            {
                uri: "/app/listar-voluntariado",
                label: 'Voluntários',
                type: "nav-item"
            },
        
        ]
    },
    {

        label: 'sidebar.menu.voluntariadoAssistenciaEspiritual',
        type: "collapsible",
        icon: <VolunteerActivismIcon sx={{fontSize: 20}}/>,
        children: [
            {
                uri: "/app/listar-equipes-inserir-voluntario",
                label: 'Alocação de Colaboradores',
                type: "nav-item"
            },
            {
                uri: "/app/listar-equipes",
                label: 'Livros (Equipe)',
                type: "nav-item"
            },
        
        ]
    },
];

export default menus;
